export default "__VITE_ASSET__BjBD89I0__"